module.exports = __webpack_public_path__ + "img/design.a65c77a3.svg";